// extracted by mini-css-extract-plugin
export default {"container":"b987b5c0","showDetails":"e2bb0abc","fieldTitleRow":"b3e3b03c"};